const mediaItems = [
  {
    title: '糖心影视 · 品牌形象片',
    desc: '感受糖心影视平台的魅力，用光影连接每一个热爱电影的你。',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20brand%20film%20atmosphere%20with%20warm%20spotlight%20effect%2C%20elegant%20theater%20curtain%20draped%20in%20coral%20and%20gold%20fabric%2C%20soft%20dramatic%20lighting%2C%20luxurious%20cinema%20aesthetic%2C%20no%20text%20no%20people&width=640&height=380&seq=media-01&orientation=landscape',
    duration: '02:15',
  },
  {
    title: '幕后故事：我们的内容之道',
    desc: '糖心影视团队分享如何为你甄选每一部优质影片。',
    img: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20creative%20workspace%20with%20warm%20ambient%20lighting%2C%20film%20editing%20aesthetic%2C%20coral%20and%20amber%20color%20palette%2C%20modern%20creative%20studio%20vibe%2C%20no%20people%20no%20text&width=640&height=380&seq=media-02&orientation=landscape',
    duration: '04:32',
  },
  {
    title: '用户故事：我与糖心的甜蜜时光',
    desc: '听听糖心影视的用户讲述他们与平台的故事。',
    img: 'https://readdy.ai/api/search-image?query=A%20cozy%20living%20room%20with%20warm%20cinematic%20lighting%20from%20a%20screen%2C%20comfortable%20atmosphere%20in%20coral%20and%20golden%20hues%2C%20home%20theater%20aesthetic%2C%20relaxed%20evening%20mood%2C%20no%20people%20no%20text&width=640&height=380&seq=media-03&orientation=landscape',
    duration: '03:18',
  },
  {
    title: '夏日观影季 · 精彩集锦',
    desc: '2026暑期档最值得期待的影视内容一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=A%20vibrant%20summer%20cinematic%20montage%20with%20warm%20sunlight%20flares%2C%20abstract%20film%20elements%2C%20coral%20and%20gold%20color%20scheme%2C%20energetic%20festival%20atmosphere%2C%20joyful%20mood%2C%20no%20text%20no%20people&width=640&height=380&seq=media-04&orientation=landscape',
    duration: '05:41',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            精彩影像
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            糖心影视的精彩瞬间与幕后故事，用影像记录我们的成长
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-all cursor-pointer"
            >
              <div className="relative w-full h-[200px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/30 transition-all"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 group-hover:text-background-50 transition-all shadow-lg">
                    <i className="ri-play-fill text-xl md:text-2xl"></i>
                  </span>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 text-[10px] font-medium bg-background-950/70 text-background-50 rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}